// import React from "react";

// const steps = [
//   {
//     icon: "bx bx-calendar-heart",
//     bg: "bg-primary",
//     title: "Choose Date & Locations",
//     desc: "Determine the date & location for your car rental. Consider factors such as your travel itinerary, pickup/drop-off locations",
//   },
//   {
//     icon: "bx bxs-edit-location",
//     bg: "bg-secondary-100",
//     title: "Select Pick-Up & Drop Locations",
//     desc: "Check the availability of your desired vehicle type for your chosen dates and location. Ensure rental rates, taxes and fees.",
//   },
//   {
//     icon: "bx bx-coffee-togo",
//     bg: "bg-dark",
//     title: "Book your Car",
//     desc: "Determine the date & location for your car rental. Consider factors such as your travel itinerary and pickup/drop-off locations",
//   },
// ];

// // const counters = [
// //   { number: "16", suffix: "K+", label: "Happy Customers" },
// //   { number: "2547", suffix: "K+", label: "Count of Cars" },
// //   { number: "625", suffix: "K+", label: "Locations to Pickup" },
// //   { number: "15000", suffix: "K+", label: "Total Kilometers" },
// // ];
// const counters = [
//   { number: "7000", suffix: "", label: "Road Trips" },
//   { number: "300", suffix: "", label: "Drivers" },
//   { number: "250", suffix: "", label: "Our Vehicle Fleet" },
//   { number: "10000", suffix: "", label: "Happy Customers" },
// ];

// const RentalSteps = () => {
//   return (
//     <section className="rental-section-four">
//       <div className="container">

//         <div className="row align-items-center">

//           {/* Left Image */}
//           <div className="col-lg-7">
//             <div className="rental-img">
//               <img
//                 src="/img/about/rent-car.png"
//                 alt="rent car"
//                 className="img-fluid"
//               />

//               <div className="grid-img">
//                 <img
//                   src="/img/about/car-grid.png"
//                   alt="car grid"
//                   className="img-fluid"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Right Content */}
//           <div className="col-lg-5">
//             <div className="rental-content">

//               <div
//                 className="section-heading heading-four text-start"
//                 data-aos="fade-down"
//               >
//                 <h2>Rent Our Cars in 3 Steps</h2>
//                 <p>Check how it Works to Rent Cars in DreamsRent</p>
//               </div>

//               {steps.map((step, index) => (
//                 <div key={index} className="step-item d-flex align-items-center">
//                   <span className={`step-icon ${step.bg} me-3`}>
//                     <i className={step.icon}></i>
//                   </span>

//                   <div>
//                     <h5>{step.title}</h5>
//                     <p>{step.desc}</p>
//                   </div>
//                 </div>
//               ))}

//             </div>
//           </div>
//         </div>

//         {/* Counter Section */}
//         <div className="count-sec">
//           <div className="row row-gap-4">

//             {counters.map((item, index) => (
//               <div key={index} className="col-lg-3 col-md-6 d-flex">
//                 <div className="count-item flex-fill">
//                   <h3>
//                     <span className="counterUp">{item.number}</span>
//                     {item.suffix}
//                   </h3>
//                   <p className="text-white">{item.label}</p>
//                 </div>
//               </div>
//             ))}

//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default RentalSteps;



import React from "react";

const steps = [
  {
    icon: "bx bx-calendar-heart",
    bg: "bg-dark",
    title: "Book Your Ride",
    desc: "Select your pickup location, destination, and time. Choose from a variety of ride options to suit your travel needs.",
  },
  {
    icon: "bx bxs-edit-location",
    bg: "bg-secondary-100",
    title: "Confirm Driver & Vehicle",
    desc: "Once booked, our system assigns a nearby driver and vehicle for your convenience. Track your cab in real-time.",
  },
  {
    icon: "bx bx-coffee-togo",
    bg: "bg-dark",
    title: "Enjoy Your Ride",
    desc: "Hop in and enjoy a safe, comfortable journey. Pay seamlessly through app or cash and reach your destination stress-free.",
  },
];

const counters = [
  { number: "7000", suffix: "", label: "Road Trips" },
  { number: "300", suffix: "", label: "Drivers" },
  { number: "250", suffix: "", label: "Our Vehicle Fleet" },
  { number: "10000", suffix: "", label: "Happy Customers" },
];

const RentalSteps = () => {
  return (
    <section className="rental-section-four">
      <div className="container">

        <div className="row align-items-center">

          {/* Left Image */}
          <div className="col-lg-7">
            <div className="rental-img">
              <img
                src="/images/Srs.png"
                alt="SRS Cab"
                className="img-fluid"
              />
              <div className="grid-img">
                <img
                  src="/img/about/cab-grid.png"
                  alt="cab grid"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-5">
            <div className="rental-content">

              <div
                className="section-heading heading-four text-start"
                data-aos="fade-down"
              >
                <h2>How SRS Cab Service Works</h2>
                <p>Simple steps to book and enjoy your ride safely and conveniently</p>
              </div>

              {steps.map((step, index) => (
                <div key={index} className="step-item d-flex align-items-center">
                  <span className={`step-icon ${step.bg} me-3`}>
                    <i className={step.icon}></i>
                  </span>

                  <div>
                    <h5>{step.title}</h5>
                    <p>{step.desc}</p>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>

        {/* Counter Section */}
        <div className="count-sec">
          <div className="row row-gap-4">

            {counters.map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6 d-flex">
                <div className="count-item flex-fill">
                  <h3>
                    <span className="counterUp">{item.number}</span>
                    {item.suffix}
                  </h3>
                  <p className="text-white">{item.label}</p>
                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
};

export default RentalSteps;